import { useState } from 'react';
import NotificationActionLayout, { NotificationActionLayoutType } from "../../components/NotificationActionLayout/NotificationActionLayout";
import { handleRequest } from "../../infra/utils";
import { getApproveInvoiceContent } from "./NotificationAction.utils";
import { useStoreActions } from "../../store/store-context";
import { jsx as _jsx } from "react/jsx-runtime";
const ApproveInvoiceAction = _ref => {
  let {
    token,
    invoiceFormattedNumber,
    vendorName,
    invoiceFormattedAmount
  } = _ref;
  const {
    api
  } = useStoreActions();
  const [approveResultContent, setApproveResultContent] = useState();
  const [loading, setLoading] = useState(false);
  async function sendApproveInvoiceAction() {
    setLoading(true);
    const invoiceApproveResult = await handleRequest(api.invoice.approveInvoiceFromEmail({
      approvalToken: token
    }));
    const content = getApproveInvoiceContent({
      invoiceApproveResult,
      vendorName,
      invoiceFormattedNumber
    });
    setApproveResultContent(content);
    setLoading(false);
  }
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "approve-invoice-action-page",
    children: /*#__PURE__*/_jsx(NotificationActionLayout, {
      state: loading ? {
        type: NotificationActionLayoutType.Loading
      } : approveResultContent ? {
        type: NotificationActionLayoutType.AfterAction,
        afterAction: approveResultContent
      } : {
        type: NotificationActionLayoutType.BeforeAction,
        beforeAction: {
          header: "Click the button below to approve the ".concat(invoiceFormattedAmount, " payment for invoice ").concat(invoiceFormattedNumber),
          buttonText: 'Approve payment',
          onClick: sendApproveInvoiceAction
        }
      }
    })
  });
};
export default ApproveInvoiceAction;